// /* eslint-disable */
// import React from "react";
// import { Link, useLocation } from "react-router-dom";
// import DashIcon from "components/icons/DashIcon";
// // chakra imports

// export function SidebarLinks(props) {
//   // Chakra color mode
//   let location = useLocation();

//   const { routes } = props;

//   // verifies if routeName is the one active (in browser input)
//   const activeRoute = (routeName) => {
//     return location.pathname.includes(routeName);
//   };
//   const createLinks = (routes) => {
//     return routes.map((route, index) => {
//       if (
//         route.layout === "/admin" ||
//         route.layout === "/auth" ||
//         route.layout === "/rtl"
//       ) {
//         return (
//           <Link key={index} to={route.layout + "/" + route.path}>
//             <div className="relative mb-3 flex hover:cursor-pointer">
//               <li
//                 className="my-[3px] flex cursor-pointer items-center px-8"
//                 key={index}
//               >
//                 <span
//                   className={`${
//                     activeRoute(route.path) === true
//                       ? "font-bold text-brand-500 dark:text-white"
//                       : "font-medium text-gray-600"
//                   }`}
//                 >
//                   {route.icon ? route.icon : <DashIcon />}{" "}
//                 </span>
//                 <p
//                   className={`leading-1 ml-4 flex ${
//                     activeRoute(route.path) === true
//                       ? "font-bold text-navy-700 dark:text-white"
//                       : "font-medium text-gray-600"
//                   }`}
//                 >
//                   {route.name}
//                 </p>
//               </li>
//               {activeRoute(route.path) ? (
//                 <div class="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
//               ) : null}
//             </div>

//             {/* Check for and render child components (recursive approach) */}
//             {route.children && (
//               <ul className="ml-4 list-none pl-8">
//                 {route.children.map((childRoute) => (
//                   <li key={childRoute.name} className="mb-2">
//                     <Link
//                       to={
//                         route.layout + "/" + route.path + "/" + childRoute.path
//                       }
//                     >
//                       {/* {childRoute.name} */}
//                       <p
//                         className={`leading-1 ml-4 flex ${
//                           activeRoute(childRoute.path) === true
//                             ? "font-bold text-navy-700 dark:text-white"
//                             : "font-medium text-gray-600"
//                         }`}
//                       >
//                         {childRoute.name}
//                       </p>
//                     </Link>

//                     {activeRoute(childRoute.path) ? (
//                       <div class="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
//                     ) : null}
//                     {/* Recursively render child components if they exist */}
//                     {/* {childRoute.children && activeRoute(childRoute)} */}
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </Link>
//         );
//       }
//     });
//   };

//   // const createLinks = (routes) => {
//   //   return routes.map((route, index) => {
//   //     if (
//   //       route.layout === "/admin" ||
//   //       route.layout === "/auth" ||
//   //       route.layout === "/rtl"
//   //     ) {
//   //       return (
//   //         <Link key={index} to={route.layout + "/" + route.path}>
//   //           <div className="relative mb-3 flex hover:cursor-pointer">
//   //             <li
//   //               className="my-[3px] flex cursor-pointer items-center px-8"
//   //               key={index}
//   //             >
//   //               <span
//   //                 className={`${
//   //                   activeRoute(route.path) === true
//   //                     ? "font-bold text-brand-500 dark:text-white"
//   //                     : "font-medium text-gray-600"
//   //                 }`}
//   //               >
//   //                 {route.icon ? route.icon : <DashIcon />}{" "}
//   //               </span>
//   //               <p
//   //                 className={`leading-1 ml-4 flex ${
//   //                   activeRoute(route.path) === true
//   //                     ? "font-bold text-navy-700 dark:text-white"
//   //                     : "font-medium text-gray-600"
//   //                 }`}
//   //               >
//   //                 {route.name}
//   //               </p>
//   //             </li>
//   //             {activeRoute(route.path) ? (
//   //               <div class="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
//   //             ) : null}
//   //           </div>
//   //         </Link>
//   //       );
//   //     }
//   //   });
//   // };
//   // BRAND
//   return createLinks(routes);
// }

// export default SidebarLinks;

// <<<<<<<<<<<<<<<<<<...................Updated ------------------------------>>>>>>>>>>>>>>>
// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import DashIcon from "components/icons/DashIcon";
// import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
// import { useSelector } from "react-redux";
// // chakra imports

// export function SidebarLinks(props) {
//   // Chakra color mode
//   let location = useLocation();

//   const { routes } = props;

//   // State to control the visibility of children
//   const [activeParents, setActiveParents] = useState({});
//   const language = useSelector((state) => state?.user?.language);

//   // verifies if routeName is the one active (in browser input)
//   const activeRoute = (routeName) => {
//     return location.pathname.includes(routeName);
//   };

//   // Toggle function to toggle visibility of children
//   const toggleChildren = (route) => {
//     setActiveParents((prevState) => ({
//       // ...prevState,
//       [route.path]: !prevState[route.path],
//     }));
//   };
//   const createLinks = (routes) => {
//     return routes.map((route, index) => {
//       if (route.layout === "/admin" || route.layout === "/auth") {
//         return (
//           <div key={index}>
//             <Link
//               to={route.layout + "/" + route.path}
//               onClick={() => toggleChildren(route)}
//             >
//               <div className="relative mb-3 flex hover:cursor-pointer">
//                 <li
//                   className="my-[3px] flex cursor-pointer items-center px-8"
//                   key={index}
//                 >
//                   <span
//                     className={`${
//                       activeRoute(route.path) === true
//                         ? "font-bold text-brand-500 dark:text-white"
//                         : "font-medium text-gray-600"
//                     }`}
//                   >
//                     {route.icon ? route.icon : <DashIcon />}{" "}
//                   </span>
//                   <p
//                     className={`leading-1 ml-4 flex ${
//                       activeRoute(route.path) === true
//                         ? "font-bold text-navy-700 dark:text-white"
//                         : "font-medium text-gray-600"
//                     }`}
//                   >
//                     {route.name}
//                   </p>
//                   {/* Arrow icon to indicate expansion/collapse */}
//                   {/* {route.children && (
//                     <span className="ml-auto">
//                       {activeParents[route.path] ? (
//                         <MdKeyboardArrowUp
//                           style={{ fontSize: "24px", color: "#a3aed0" }}
//                         />
//                       ) : (
//                         <MdKeyboardArrowDown
//                           style={{ fontSize: "24px", color: "#a3aed0" }}
//                         />
//                       )}
//                     </span>
//                   )} */}
//                 </li>
//                 {activeRoute(route.path) ? (
//                   <div class="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
//                 ) : null}
//               </div>
//             </Link>
//             {/* Render children if they exist and parent is active */}
//             {route.children && activeParents[route.path] && (
//               <ul className="ml-4 list-none pl-8">
//                 {/* Render only the second child route */}
//                 <li key={route.children[1].name} className="mb-2">
//                   <Link
//                     to={
//                       route.layout +
//                       "/" +
//                       route.path +
//                       "/" +
//                       route.children[1].path
//                     }
//                     className={`${
//                       language === "ar" ? "flex justify-center" : ""
//                     }`}
//                   >
//                     {/* <p
//                       className={`leading-1 ml-4 flex ${
//                         activeRoute(route.children[1].path) === true
//                           ? "font-bold text-navy-700 dark:text-white"
//                           : "font-medium text-gray-600"
//                       }`}
//                     >
//                       {route.children[1].name}
//                     </p> */}
//                   </Link>
//                   {/* You can add toggle functionality for child's children here if needed */}
//                 </li>
//               </ul>
//             )}
//           </div>
//         );
//       }
//     });
//   };

//   // const createLinks = (routes) => {
//   //   return routes.map((route, index) => {
//   //     if (route.layout === "/admin" || route.layout === "/auth") {
//   //       return (
//   //         <div key={index}>
//   //           <Link
//   //             to={route.layout + "/" + route.path}
//   //             onClick={() => toggleChildren(route)}
//   //           >
//   //             <div className="relative mb-3 flex hover:cursor-pointer">
//   //               <li
//   //                 className="my-[3px] flex cursor-pointer items-center px-8"
//   //                 key={index}
//   //               >
//   //                 <span
//   //                   className={`${
//   //                     activeRoute(route.path) === true
//   //                       ? "font-bold text-brand-500 dark:text-white"
//   //                       : "font-medium text-gray-600"
//   //                   }`}
//   //                 >
//   //                   {route.icon ? route.icon : <DashIcon />}{" "}
//   //                 </span>
//   //                 <p
//   //                   className={`leading-1 ml-4 flex ${
//   //                     activeRoute(route.path) === true
//   //                       ? "font-bold text-navy-700 dark:text-white"
//   //                       : "font-medium text-gray-600"
//   //                   }`}
//   //                 >
//   //                   {route.name}
//   //                 </p>
//   //                 {/* Arrow icon to indicate expansion/collapse */}
//   //                 {route.children && (
//   //                   <span className="ml-auto">
//   //                     {activeParents[route.path] ? (
//   //                       <MdKeyboardArrowUp
//   //                         style={{ fontSize: "24px", color: "#a3aed0" }}
//   //                       />
//   //                     ) : (
//   //                       <MdKeyboardArrowDown
//   //                         style={{ fontSize: "24px", color: "#a3aed0" }}
//   //                       />
//   //                     )}
//   //                   </span>
//   //                 )}
//   //               </li>
//   //               {activeRoute(route.path) ? (
//   //                 <div class="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
//   //               ) : null}
//   //             </div>
//   //           </Link>
//   //           {/* Render children if they exist and parent is active */}
//   //           {route.children && activeParents[route.path] && (
//   //             <ul className="ml-4 list-none pl-8">
//   //               {route.children.map((childRoute) => (
//   //                 <li key={childRoute.name} className="mb-2">
//   //                   <Link
//   //                     to={
//   //                       route.layout + "/" + route.path + "/" + childRoute.path
//   //                     }
//   //                     className={`${
//   //                       language === "ar" ? "flex justify-center" : ""
//   //                     }`}
//   //                   >
//   //                     <p
//   //                       className={`leading-1 ml-4 flex ${
//   //                         activeRoute(childRoute.path) === true
//   //                           ? "font-bold text-navy-700 dark:text-white"
//   //                           : "font-medium text-gray-600"
//   //                       }`}
//   //                     >
//   //                       {childRoute.name}
//   //                     </p>
//   //                   </Link>
//   //                   {/* You can add toggle functionality for child's children here if needed */}
//   //                 </li>
//   //               ))}
//   //             </ul>
//   //           )}
//   //         </div>
//   //       );
//   //     }
//   //   });
//   // };

//   return createLinks(routes);
// }

// export default SidebarLinks;

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useSelector } from "react-redux";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes } = props;

  // State to control the visibility of children and arrow icon
  const [activeParents, setActiveParents] = useState({});
  const [arrowIconVisible, setArrowIconVisible] = useState(false);
  const language = useSelector((state) => state?.user?.language);

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // Toggle function to toggle visibility of children and arrow icon
  const toggleChildren = (route) => {
    setActiveParents((prevState) => ({
      ...prevState,
      [route.path]: !prevState[route.path],
    }));
    setArrowIconVisible((prevState) => !prevState);
  };

  const createLinks = (routes) => {
    console.log("routes..............===>>>",routes)
    return routes.map((route, index) => {
      if (route.layout === "/admin" || route.layout === "/auth") {
        return (
          <div key={index}>
            <Link
              to={route.layout + "/" + route.path}
              onClick={() => toggleChildren(route)}
            >
              <div className="relative mb-3 flex hover:cursor-pointer">
                <li
                  className="my-[3px] flex cursor-pointer items-center px-8"
                  key={index}
                >
                  <span
                    className={`${
                      activeRoute(route.path) === true
                        ? "font-bold text-brand-500 dark:text-white"
                        : "font-medium text-gray-600"
                    }`}
                  >
                    {route.icon ? route.icon : <DashIcon />}{" "}
                  </span>
                  <p
                    className={`leading-1 ml-4 flex ${
                      activeRoute(route.path) === true
                        ? "font-bold text-navy-700 dark:text-white"
                        : "font-medium text-gray-600"
                    }`}
                  >
                    {route.name}
                  </p>
                  {/* Arrow icon to indicate expansion/collapse */}
                  {/* {route.path === "settings" && (
                    <span className="ml-auto">
                      {arrowIconVisible ? (
                        <MdKeyboardArrowUp
                          style={{ fontSize: "24px", color: "#a3aed0" }}
                        />
                      ) : (
                        <MdKeyboardArrowDown
                          style={{ fontSize: "24px", color: "#a3aed0" }}
                        />
                      )}
                    </span>
                  )} */}
                </li>
                {activeRoute(route.path) ? (
                  <div class="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
                ) : null}
              </div>
            </Link>
            {/* Render children if they exist and parent is active */}
            {/* {route.path === "settings" && activeParents[route.path] && (
              <ul className="ml-4 list-none pl-8">
                {route.children.map((childRoute) => (
                  <li key={childRoute.name} className="mb-2">
                    <Link
                      to={
                        route.layout + "/" + route.path + "/" + childRoute.path
                      }
                      className={`${
                        language === "ar" ? "flex justify-center" : ""
                      }`}
                    >
                      <p
                        className={`leading-1 ml-4 flex ${
                          activeRoute(childRoute.path) === true
                            ? "font-bold text-navy-700 dark:text-white"
                            : "font-medium text-gray-600"
                        }`}
                      >
                        {childRoute.name}
                      </p>
                    </Link>
                  </li>
                ))}
              </ul>
            )} */}
          </div>
        );
      }
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
